import Controller from '../../../core/controller'
import Select from '../../../interaction/select'
import Utils from '../../../utils/utils'
import Storage from '../../../core/storage/storage'
import Lang from '../../../core/lang'
import Account from '../../../core/account/account'
import Device from '../../../core/account/device'

export default {
    onPriorityButton: function(btn){
        let cont = this.html.find('.full-start-new__buttons')
        let clon = btn.clone()

        cont.find('.button--priority').remove()
        
        clon.addClass('button--priority').removeClass('view--torrent').on('hover:enter',()=>{
            btn.trigger('hover:enter')
        }).on('hover:long',()=>{
            clon.remove()

            Storage.set('full_btn_priority','')

            this.last = this.html.find('.button--play')[0]

            Controller.toggle('content')
        })

        cont.prepend(clon)
    },
    onGroupButtons: function(){
        let play = this.html.find('.button--play')
        let btns = this.html.find('.buttons--container > .full-start__button').not('.hide')

        let priority = Storage.get('full_btn_priority','') + ''
        
        if(priority){
            let priority_button
            
            btns.each(function(){
                let hash = Utils.hash($(this).clone().removeClass('focus').prop('outerHTML'))

                if(hash == priority) priority_button = $(this)
            })

            if(priority_button) this.emit('priorityButton', priority_button)
        }

        let proceed = ()=>{
            let online_btn = this.html.find('.buttons--container .view--online').not('.hide').first()

            try { console.log('[lampac] proceed(): online_btn.length=' + online_btn.length + ', lampac_plugin=' + !!window.lampac_plugin) } catch(e){}

            if(online_btn.length) return online_btn.trigger('hover:enter')

            priority = Storage.get('full_btn_priority','') + ''

            btns = this.html.find('.buttons--container > .full-start__button').not('.hide').filter(function(){
                return priority !== Utils.hash($(this).clone().removeClass('focus').prop('outerHTML'))
            })

            // .view--online отсутствует — пользователь увидит селектбокс
            // (или пустой экран).
            if(btns.length == 1){
                btns.trigger('hover:enter')
            }
            else{
                let items = []

                btns.each(function(){
                    let icon = $(this).find('svg').prop('outerHTML')

                    items.push({
                        title: $(this).text(),
                        subtitle: $(this).data('subtitle'),
                        template: typeof icon == 'undefined' || icon == 'undefined' ? 'selectbox_item' : 'selectbox_icon',
                        icon: icon,
                        btn: $(this)
                    })
                })

                Select.show({
                    title: Lang.translate('settings_rest_source'),
                    items: items,
                    onSelect: (a)=>{
                        a.btn.trigger('hover:enter')
                    },
                    onLong: (a)=>{
                        Storage.set('full_btn_priority',Utils.hash(a.btn.clone().removeClass('focus').prop('outerHTML')))

                        this.emit('priorityButton', a.btn)
                    },
                    onBack: ()=>{
                        Controller.toggle('content')
                    }
                })
            }
        }

        play.unbind().on('hover:enter',(e)=>{
            try { console.log('[lampac] button--play click; access=' + !!Account.Permit.access + ', premium(local)=' + Account.hasPremium()) } catch(e){}

            // Гейт: нужна авторизация — сразу показываем экран с кодом привязки
            if(!Account.Permit.access){
                try { console.log('[lampac] gate: no auth → Device.login()') } catch(e){}
                Device.login()
                return
            }

            // Пейволла по подписке больше нет: фримиум — без подписки смотрим с рекламой,
            // гейт по Account.hasPremium() применяет сам Preroll в момент старта видео.
            // Фоново освежаем юзера, чтобы к прероллу премиум был актуален
            // (например, подписку только что оплатили в боте).
            Account.updateUser()

            try { console.log('[lampac] gate ok → proceed()') } catch(e){}
            proceed()
        }).on('hover:focus', ()=>{
            this.last = play[0]
        })
        
        // Раньше: play.toggleClass('hide', !Boolean(btns.length))
        // Из-за гонки рендера и добавления .view--online плагином, кнопка
        // прячется когда плагин ещё не успел навесить триггер. Принудительно
        // оставляем «Смотреть» видимой — клик гейтится через Account/Premium,
        // а отсутствие источников отрабатывает в proceed() (показ селектбокса).
        play.removeClass('hide')
    }
}